<div class="renderer-container" *ngIf="model">
  <mat-chip *ngIf="model.retailers && !isMultiMode" [matTooltip]="model.retailers.toolTip" class="mat-chip-small">{{model.retailers.label}}</mat-chip>
  <mat-chip *ngIf="model.filters?.toolTip" [matTooltip]="model.filters.toolTip" class="mat-chip-small">{{model.filters.label}}</mat-chip>
</div>
